// Estado de las notificaciones push para la UI (soporte, permiso, suscripción) + acciones.
// Spec: docs/2026-08-25-push-inactividad-pwa-spec.md

import { useCallback, useEffect, useState } from 'react';
import {
  activarPush,
  desactivarPush,
  estaSuscripto,
  permisoPush,
  soportePush,
  type ActivarResultado,
  type PushSoporte,
} from '../lib/push';

export interface PushState {
  soporte: PushSoporte;
  permiso: NotificationPermission | 'unsupported';
  suscripto: boolean;
  cargando: boolean;
}

export function usePushNotifications() {
  const [state, setState] = useState<PushState>({
    soporte: 'sin-soporte',
    permiso: 'default',
    suscripto: false,
    cargando: true,
  });

  const refrescar = useCallback(async () => {
    const soporte = soportePush();
    const permiso = permisoPush();
    const suscripto = await estaSuscripto();
    setState({ soporte, permiso, suscripto, cargando: false });
  }, []);

  useEffect(() => {
    void refrescar();
  }, [refrescar]);

  const activar = useCallback(async (): Promise<ActivarResultado> => {
    setState((s) => ({ ...s, cargando: true }));
    const r = await activarPush();
    await refrescar();
    return r;
  }, [refrescar]);

  const desactivar = useCallback(async () => {
    setState((s) => ({ ...s, cargando: true }));
    await desactivarPush();
    await refrescar();
  }, [refrescar]);

  return { ...state, activar, desactivar, refrescar };
}
